export const galleryImages = [
  {
    id: 1,
    image: "/gallery/IMG_8212.jpeg",
    title: "Makeup & Styling",
    category: "Bridal Services",
  },
  {
    id: 2,
    image: "/gallery/TBF_0130.jpg",
    title: "Makeup & Styling",
    category: "Bridal Services",
  },
  {
    id: 3,
    image: "/gallery/TBF_0180.jpg",
    title: "Makeup & Styling",
    category: "Bridal Services",
  },
  {
    id: 4,
    image: "/gallery/IMG_9756.jpeg",
    title: "Layer Cut",
    category: "Hair Services",
  },
  {
    id: 5,
    image: "/gallery/IMG_0947.jpeg",
    title: "Layer Cut",
    category: "Hair Services",
  },
  {
    id: 6,
    image: "/gallery/IMG_9985.jpeg",
    title: "Bob Cut",
    category: "Hair Services",
  },
  {
    id: 7,
    image: "/gallery/IMG_3172.PNG",
    title: "Low Fade",
    category: "Hair Services",
  },
  {
    id: 8,
    image: "/gallery/IMG_3170.jpg",
    title: "Low Taper Fade",
    category: "Hair Services",
  },
  {
    id: 9,
    image: "/gallery/IMG_3173.PNG",
    title: "Mullet Fade",
    category: "Hair Services",
  },
  {
    id: 10,
    image: "/gallery/IMG_3169.jpg",
    title: "Hair Color",
    category: "Hair Services",
  },
  {
    id: 11,
    image: "/gallery/IMG_3175.jpg",
    title: "Layer Cut",
    category: "Hair Services",
  },
  {
    id: 12,
    image: "/gallery/IMG_3174.jpg",
    title: "Hair Color",
    category: "Hair Services",
  },
];

export const galleryCategories = [
  "All",
  "Hair Services",
  "Beauty Services",
  "Bridal Services",
  "Grooming",
  "Special Events",
  "Salon",
];
